import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type AccountManager from "./AccountManager";
import type Organisation from "./Organisation";

@Model()
class OrganisationsManager extends ApplicationRecord {
  static jsonapiType = "organisations_managers";

  @Attr({ persist: false }) archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() manager: AccountManager;

  @Attr() managerId: number;

  @Attr() managerType: string;

  @Attr({ persist: false }) name: string;

  @BelongsTo() organisation: Organisation;

  @Attr() primary: boolean;

  static notArchived() {
    return this.where({ archived: { eq: false } });
  }
}

export default OrganisationsManager;
